module.exports = __webpack_public_path__ + "static/media/copy_MTCN.a9cce7f1.svg";